import React, { FC, useCallback, useState } from 'react';
import styled from 'styles/styled-components';

import media from 'utils/mediaStyle';

import { Button, Card, Skeleton } from 'antd';
import ModalNote from 'components/Checkout/ProductNoteModal';
import NewMarketItem from 'components/MarketItem/NewMarketItem';
import { Viewport } from 'components/ViewportProvider';
import { push } from 'connected-react-router';
import { IHomeFavoritePayload, IHomeProductNotePayload } from 'containers/HomePage/types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { Product, TrackingAddToCartAddFromType, TrackingProductImpressionType } from 'types/schema';
import { commonDimensions } from 'utils/constants';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import { selectAddedProducts, selectAddingProducts, selectUserPermissions } from '../../../MainLayout/selectors';
import { AddedProduct, AddingProduct } from '../../../MainLayout/types';
import { setProductSourceFavorite, setProductSourceNote } from '../actions';
import {
  KAMEREO_FRESH_FRUIT,
  KAMEREO_FRESH_FRUIT_EN,
  KAMEREO_FRESH_FRUIT_MOBILE,
  KAMEREO_FRESH_FRUIT_MOBILE_EN,
  KAMEREO_FRESH_INGREDIENTS,
  KAMEREO_FRESH_INGREDIENTS_EN,
  KAMEREO_FRESH_INGREDIENTS_MOBILE,
  KAMEREO_FRESH_INGREDIENTS_MOBILE_EN,
  KAMEREO_FRESH_READY_TO_EAT,
  KAMEREO_FRESH_READY_TO_EAT_EN,
  KAMEREO_FRESH_READY_TO_EAT_MOBILE,
  KAMEREO_FRESH_READY_TO_EAT_MOBILE_EN,
} from '../Images';
import messages from '../messages';
import selectKamereoFreshPage, { selectNoteItemLoading } from '../selectors';
import { ContainerState, KamereoFreshSectionEnum } from '../types';
import SVGIcon from '../../../../components/SVGIcon/SVGIcon';
import MapPin from '../Images/mapPin.svg';

export const SectionContainer = styled.div`
  background: #ffffff;
  padding: 40px 0px 22px;
  // overflow: hidden;
  position: relative;
  margin-top: 8px;
  ${media.md`
    padding: 40px 0px;
    margin-top: 0px;
    `}
`;

export const Container = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  margin: 0 auto;
  background: #f5f5f4;
  padding: 0px;
  ${media.md`
    padding: 0 16px;
    background: transparent;
   `}
`;

export const SectionTitleBox = styled.div`
  width: 100%;
  margin-bottom: 24px;
  ${media.lg`
    margin-bottom: 40px;
    `}
`;

export const SectionTitle = styled.h3`
  display: inline;
  justify-content: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  color: #242527;
  ${({ highLight }) =>
    highLight &&
    `
    color: #3C9041;
  `}
  ${media.lg`
    font-size: 40px;
    line-height: 48px;
    `}
  ${media.md`
    display: flex;
    font-size: 40px;
    line-height: 48px;
    `}
    ${({ initial }) =>
    initial &&
    `
      justify-content: flex-start;
    `}
  ${({ flex }) =>
    flex &&
    `
    display: inline;
  `}
`;

const ProductSourceContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  &:not(:last-child) {
    padding-bottom: 22px;
    ${media.lg`
      padding-bottom: 32px;
    `};
    @media (max-width: 767px) {
      margin-bottom: 8px;
    }
  }
  &:not(:first-child) {
    padding-top: 40px;
    ${media.lg`
      padding-top: 32px;
    `};
  }
`;

const List = styled('div')`
  padding: 1px 16px;
  display: flex;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 16px;
  ${media.lg`
    padding: 1px;
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  `};
`;

const SkeletonImage = styled(Skeleton.Image)`
  width: 100% !important;
  & > div {
    width: 100% !important;
    height: 200px !important;
  }
`;

const Item = styled('div')`
  ${media.md`
    width:100%;
  `};
  flex: 0 0 152px;
  width: 152px;
`;

const SectionTitleWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
  @media (max-width: 767px) {
    margin-bottom: 12px;
    padding: 0 16px;
  }
`;

const SectionTitleBackground = styled.img`
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonContainer = styled(Button)`
  height: 40px;
  padding: 12px;
  border-radius: 8px;
  color: #2f382c;
  border-color: #d5d7d5;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  background: transparent;
  display: flex;
  align-items: center;
  &:hover {
    color: #43a047 !important;
    border-color: #43a047 !important;
  }
  &:active {
    border-color: #2f7434 !important;
    color: #2f7434 !important;
  }
  ${media.md`
    font-size: 16px;
    `}
`;

const RedirectLink = styled.div`
  position: absolute;
  bottom: 16px;
  right: 18px;
  cursor: pointer;
  padding: 7px 12px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid rgba(255, 255, 255, 0.85);
  @media (max-width: 767px) {
    bottom: 14px;
    left: 50%;
    transform: translateX(-50%);
    width: fit-content;
    padding: 4px 8px;
  }
  &:hover {
    border-color: #43a047;
  }
`;

const RedirectLinkText = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #43a047;
  line-height: 20px;
  @media (max-width: 767px) {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
`;

interface OwnProps {}

export interface IStateProps {
  kamereoFreshPage: ContainerState;
  addedProducts: AddedProduct;
  addingProducts: AddingProduct;
  permissions: string[];
  noteItemLoading: boolean;
}

interface IDispatchProps {
  onToggleFavorite: (data: IHomeFavoritePayload) => void;
  onSetProductNote: (data: IHomeProductNotePayload) => void;
  gotoSignIn: () => void;
  gotoTagPage: (path: string) => void;
  goToRTEPage: () => void;
}

type IProps = OwnProps & IStateProps & IDispatchProps;

const sectionImages = {
  vi: {
    [KamereoFreshSectionEnum?.Fruit]: KAMEREO_FRESH_FRUIT,
    [KamereoFreshSectionEnum?.ReadyToEat]: KAMEREO_FRESH_READY_TO_EAT,
    [KamereoFreshSectionEnum?.FreshIngredients]: KAMEREO_FRESH_INGREDIENTS,
  },
  en: {
    [KamereoFreshSectionEnum?.Fruit]: KAMEREO_FRESH_FRUIT_EN,
    [KamereoFreshSectionEnum?.ReadyToEat]: KAMEREO_FRESH_READY_TO_EAT_EN,
    [KamereoFreshSectionEnum?.FreshIngredients]: KAMEREO_FRESH_INGREDIENTS_EN,
  },
};

const sectionImagesMobile = {
  vi: {
    [KamereoFreshSectionEnum?.Fruit]: KAMEREO_FRESH_FRUIT_MOBILE,
    [KamereoFreshSectionEnum?.ReadyToEat]: KAMEREO_FRESH_READY_TO_EAT_MOBILE,
    [KamereoFreshSectionEnum?.FreshIngredients]: KAMEREO_FRESH_INGREDIENTS_MOBILE,
  },
  en: {
    [KamereoFreshSectionEnum?.Fruit]: KAMEREO_FRESH_FRUIT_MOBILE_EN,
    [KamereoFreshSectionEnum?.ReadyToEat]: KAMEREO_FRESH_READY_TO_EAT_MOBILE_EN,
    [KamereoFreshSectionEnum?.FreshIngredients]: KAMEREO_FRESH_INGREDIENTS_MOBILE_EN,
  },
};

const Meta = Card.Meta;
export const ProductSkeleton = () => (
  <List gutter={[16, 16]}>
    {[...Array(5)].map((_, idx) => (
      <div key={idx}>
        <Card style={{ width: '100%' }} styles={{ cover: { width: '100%' } }} cover={<SkeletonImage active />}>
          <Meta title={<Skeleton.Input active style={{ height: '20px' }} />} />
          <Meta
            style={{ marginTop: '4px', width: '60%' }}
            title={<Skeleton.Input active style={{ height: '20px' }} />}
          />
          <Meta
            style={{ marginTop: '8px', width: '80%' }}
            title={<Skeleton.Input active style={{ height: '20px' }} />}
          />
          <Meta
            style={{ marginLeft: 'auto', marginTop: '10px', width: '75%' }}
            title={<Skeleton.Input active style={{ height: '30px' }} />}
          />
        </Card>
      </div>
    ))}
  </List>
);

const MAXIMUM_ITEMS_ON_ROW = 4;

const ProductsSource: FC<IProps> = (props) => {
  const [selectedProduct, setSelectedProduct] = useState<Product>();
  const [selectedSection, setSelectedSection] = useState<string>('');

  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [isOpenNoteModal, setIsOpenNoteModal] = useState<boolean>(false);
  const [showAllInSection, setShowAllInSection] = useState({});
  const lang = localStorage.getItem('lang') || 'vi';
  const {
    kamereoFreshPage: { sections },
    gotoSignIn,
    onToggleFavorite,
    onSetProductNote,
    addedProducts,
    addingProducts,
    permissions,
    noteItemLoading,
    goToRTEPage,
  } = props;

  const loggedIn = !!localStorage.getItem('token');
  const onClickOpenNoteModal = useCallback(
    (product: Product, index: number, sectionName: string) => {
      if (loggedIn) {
        setSelectedProduct(product);
        setSelectedSection(sectionName);
        setSelectedIndex(index);
        setIsOpenNoteModal(true);
      } else {
        gotoSignIn();
      }
    },
    [setSelectedProduct, setSelectedIndex, setIsOpenNoteModal, loggedIn],
  );

  const onClickCloseNoteModal = useCallback(() => {
    setSelectedProduct(undefined);
    setSelectedSection('');
    setSelectedIndex(-1);
    setIsOpenNoteModal(false);
  }, [setSelectedProduct, setSelectedIndex, setIsOpenNoteModal]);

  const scrollToSection = (id, offset = 100) => {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top });
    }
  };

  const onSubmitAddingNote = useCallback(
    (note: string) => {
      if (selectedProduct) {
        onSetProductNote({
          index: selectedIndex,
          section: selectedSection,
          note: note,
          id: selectedProduct.id,
        });
      }
      onClickCloseNoteModal();
    },
    [selectedProduct, selectedIndex, onClickCloseNoteModal, selectedSection],
  );
  return (
    <SectionContainer>
      <Container className={'container-padding'}>
        {Object.entries(sections).map(([sectionName, sectionData]) => (
          <Viewport.Consumer key={sectionName}>
            {({ width }) => (
              <ProductSourceContainer id={sectionName}>
                <SectionTitleWrapper>
                  <SectionTitleBackground
                    src={
                      width > 767 ? sectionImages?.[lang]?.[sectionName] : sectionImagesMobile?.[lang]?.[sectionName]
                    }
                  />
                  {sectionName === KamereoFreshSectionEnum.Fruit && (
                    <RedirectLink onClick={() => window.open('/he-thong-phan-phoi', '_blank')}>
                      <RedirectLinkText>
                        {lang === 'vi' ? 'Xem địa điểm phân phối' : 'View Distribution Locations'}
                      </RedirectLinkText>
                      <SVGIcon src={MapPin} renderAsImg={false} />
                    </RedirectLink>
                  )}
                </SectionTitleWrapper>
                <List>
                  {!!sectionData?.data?.length &&
                    (() => {
                      const data =
                        showAllInSection[sectionName] || width < 768
                          ? sectionData?.data
                          : sectionData?.data.slice(0, MAXIMUM_ITEMS_ON_ROW);
                      return data?.map((product: Product, index: number) => (
                        <Item key={product.id}>
                          <NewMarketItem
                            vertialOnly
                            listName="Section Product List"
                            loggedIn={loggedIn}
                            gotoSignIn={gotoSignIn}
                            product={product}
                            favorite={product.isFavorite}
                            note={product.note}
                            added={addedProducts[product.id]}
                            adding={addingProducts[product.id]}
                            position={index}
                            permissions={permissions}
                            onToggleFavorite={() =>
                              onToggleFavorite({ product: product, index: index, section: sectionName })
                            }
                            onOpenNote={() => onClickOpenNoteModal(product, index, sectionName)}
                            onDeleteNote={() => {
                              onSetProductNote({ index: index, section: sectionName, note: '', id: product.id });
                              onClickCloseNoteModal();
                            }}
                            impressionProperties={{ type: TrackingProductImpressionType.CartProduct }}
                            addToCartProperties={{ addFrom: TrackingAddToCartAddFromType.CartProduct }}
                            ga4Callback={({ category, supplierInternalCode, id }) =>
                              sendGA4Event(EventName.CLICK_PRODUCT_ITEM_FTB, {
                                product_category_ftb: `${category?.parent?.name}/${category?.name}`,
                                product_sku_ftb: supplierInternalCode,
                                product_id_ftb: id,
                              })
                            }
                            isShowFrame={false}
                          />
                        </Item>
                      ));
                    })()}
                </List>
                {(sectionData?.fetching || !sectionData?.data?.length) && <ProductSkeleton />}
                <ModalNote
                  headerLabel={(selectedProduct && selectedProduct.name) || ''}
                  isOpen={isOpenNoteModal}
                  confirmLoading={noteItemLoading}
                  onSubmit={onSubmitAddingNote}
                  onClose={onClickCloseNoteModal}
                  note={(selectedProduct && selectedProduct.note) || ''}
                />
                {Number(sectionData?.totalResults) > MAXIMUM_ITEMS_ON_ROW && width > 767 && (
                  <ButtonWrapper>
                    <ButtonContainer
                      loading={sectionData?.loading}
                      onClick={() => {
                        setShowAllInSection({
                          ...showAllInSection,
                          [sectionName]: !showAllInSection?.[sectionName],
                        });
                        if (showAllInSection?.[sectionName]) {
                          scrollToSection(sectionName);
                        }
                      }}
                    >
                      {showAllInSection?.[sectionName] ? (
                        <FormattedMessage {...messages.collapse} />
                      ) : (
                        <FormattedMessage
                          {...messages.seeMore}
                          values={{ count: sectionData?.data?.length - MAXIMUM_ITEMS_ON_ROW }}
                        />
                      )}
                    </ButtonContainer>
                  </ButtonWrapper>
                )}
              </ProductSourceContainer>
            )}
          </Viewport.Consumer>
        ))}
      </Container>
    </SectionContainer>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  kamereoFreshPage: selectKamereoFreshPage(),
  addedProducts: selectAddedProducts(),
  addingProducts: selectAddingProducts(),
  permissions: selectUserPermissions(),
  noteItemLoading: selectNoteItemLoading(),
});
const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onToggleFavorite: (data: IHomeFavoritePayload) => dispatch(setProductSourceFavorite(data)),
  onSetProductNote: (data: IHomeProductNotePayload) => dispatch(setProductSourceNote(data)),
  gotoSignIn: () => dispatch(push('/signin')),
  gotoTagPage: (path) => dispatch(push(path)),
  goToRTEPage: () => dispatch(push('/he-thong-phan-phoi')),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ProductsSource);
